import {
  DetailsColumn,
  DetailsContainer,
  DetailsLabel,
  DetailsRow,
  DetailsText,
} from "../../../../constants/component.constants";
import { formatCurrency } from "../../../../util/util";
import ModalContainerModule from "../../../modules/modalContainer";

const ViewMeterModal = ({ openModal, selectedMeter, closeModal }) => {
  return (
    <ModalContainerModule
      openModal={openModal}
      cancel={closeModal}
      modalTitle={`View Meter: ${selectedMeter?.name}`}
      size="small"
      cancelText="Cancel"
    >
        <DetailsContainer sx={{ width: "100%" }}>
          <DetailsColumn
            sx={{
              width: { lg: "50%", xs: "100%" },
            }}
          >
            <DetailsRow>
              <DetailsLabel>Meter Name</DetailsLabel>
              <DetailsText>
                {selectedMeter?.name}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Meter Type</DetailsLabel>
              <DetailsText>
                {selectedMeter?.meterType}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Meter Reading Frequency</DetailsLabel>
              <DetailsText>
                {selectedMeter?.readingFrequencyName}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Facility/Complex</DetailsLabel>
              <DetailsText>
                {selectedMeter?.attachedTo?.split(",")[0] || ""}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Attachment Type</DetailsLabel>
              <DetailsText>
                {selectedMeter?.facilityId ? "Facility" : selectedMeter?.complexId ? "Complex" : ""}
              </DetailsText>
            </DetailsRow>
          </DetailsColumn>
          <DetailsColumn
            sx={{
              width: { lg: "50%", xs: "100%" },
            }}
          >
            <DetailsRow>
              <DetailsLabel>Unit</DetailsLabel>
              <DetailsText>
                {selectedMeter?.unitName}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Rate Type</DetailsLabel>
              <DetailsText>
                {selectedMeter?.rateTypeName}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Rate</DetailsLabel>
              <DetailsText>
                Ksh {formatCurrency(selectedMeter?.rate)}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Standing Charge</DetailsLabel>
              <DetailsText>
                Ksh {formatCurrency(selectedMeter?.standingCharge)}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Invoiced</DetailsLabel>
              <DetailsText>
                {selectedMeter?.invoiced ? "Yes" : "No"}
              </DetailsText>
            </DetailsRow>
          </DetailsColumn>
        </DetailsContainer>
    </ModalContainerModule>
  );
};

export default ViewMeterModal;
